import { Injectable } from '@angular/core';
import { HttpProviderService } from 'src/app/core/services';
import { AccountDetails } from 'src/app/models/account-info.model';
import { CustomerService } from 'src/app/services/customer.service';

@Injectable()

export class AccountListService {
  accountSummary: AccountDetails[];
  constructor(
    private httpProvider: HttpProviderService,
    private customerService: CustomerService
  ) { }

  getAccounts(accType): AccountDetails[] {
    return this.customerService.getAccount(accType);
  }
}
